import { cookieAuthStorageService } from "@features/user/utils/cookieAuthStorageService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { authSlice } from "../slice";
import { AuthData } from "../types";
import { invalidateUserBasedQueries } from "./invalidateUserBasedQueries";

export const setAuthData = createAsyncThunk<void, AuthData>(
  "auth/setAuthData",
  (args, { dispatch }) => {
    dispatch(authSlice.actions.setAuthDataInStorage(args));

    if (cookieAuthStorageService.isCanUse) {
      cookieAuthStorageService.setToken(args.token);
    }
    dispatch(invalidateUserBasedQueries());
  }
);
